import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import Hero3DShowcase from './Hero3DShowcase';
import MagneticButton from './MagneticButton';
import '../styles/Home.css';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);

    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollY(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Mobile: subtle parallax, Desktop: more dramatic
  const zoom = isMobile ? 1 + (scrollY / 5000) * 0.08 : 1 + (scrollY / 3000) * 0.15;
  const clampedZoom = Math.min(zoom, isMobile ? 1.08 : 1.15);
  const translateY = isMobile ? scrollY * 0.3 : scrollY * 0.5;
  const contentTranslateY = isMobile ? scrollY * 0.15 : scrollY * 0.2;

  return (
    <section className="hero cinematic-hero">
      <Hero3DShowcase />
      <div 
        className="hero-background mobile-parallax-slow" 
        style={{ 
          transform: `translateY(${translateY}px) scale(${clampedZoom}) translateZ(0)`,
          opacity: 1 - (scrollY / 800)
        }}
      />
      <div className="container">
        <div className="hero-content mobile-parallax-fast" style={{ transform: `translateY(${contentTranslateY}px) translateZ(0)` }}>
          <div className="demo-badge floating cinema-entrance mobile-float">Projekt demonstracyjny</div>
          <h1 className="hero-large floating-delayed cinema-entrance-delayed mobile-float">Nowoczesny sklep internetowy</h1>
          <p className="hero-subtitle body-large floating-delayed-2 cinema-entrance-delayed-2 mobile-float">
            Sklep zaprojektowany, aby zwiększać sprzedaż i przyciągać klientów
          </p>
          <MagneticButton 
            className="btn-primary btn-glow floating-delayed-3 cinema-entrance-delayed-3" 
            onClick={scrollToProducts}
          >
            Zobacz produkty
            <ArrowRight size={18} style={{ marginLeft: '12px' }} />
          </MagneticButton>
        </div>
      </div>
    </section>
  );
};

export default Hero;
